import React, { useState, useEffect, Fragment } from "react";
import { useNavigate } from 'react-router-dom';
import './sign.scss';
import Textfield from "../../components/textfield";
import Button, { ButtonRouter } from "../../components/button";
import Container from "../../components/container";
import { validateEmail } from "../../../scripts/helpers/validators";
import useGlobal from "../../../store";
import { DOCUMENTS, MOBILE_VERSION_MAXWIDTH } from "../../../settings/constants";
import Checkbox from "../../components/checkbox";

const Up = () => {

  const [ globalState, globalActions ] = useGlobal();
  const { sign } = globalActions;

  const navigate = useNavigate();

  const [ email, setEmail ] = useState("");
  const [ password, setPassword ] = useState("");
  const [ repeat, setRepeat ] = useState("");
  const [ offerAccepted, setOfferAccepted ] = useState( false );
  const [ privacyAccepted, setPrivacyAccepted ] = useState( false );
  const [ error, setError ] = useState("");

  const isFormValidated = validateEmail( email ) && password !== "" && password === repeat && offerAccepted && privacyAccepted;

  function handleSignUp() {

    const isMobile = window?.innerWidth < MOBILE_VERSION_MAXWIDTH;
    const gotoApp = () => navigate( isMobile ? '/deals' : '/' );
    sign.Up( email, password, repeat, gotoApp, setError );

  }

  useEffect( () => { error !== "" && setError(""); }, [ email, password, repeat ] );

  useEffect( () => {

    ( 
      validateEmail( email ) 
      && 
      password !== "" 
      && 
      password !== repeat 
      && 
      offerAccepted 
      && 
      privacyAccepted ) && setError("Пароли не совпадают!"
    )

  }, [

    email,
    password,
    repeat,
    offerAccepted,
    privacyAccepted

  ]);
  
  return (

    <Container clear>

      <div className = "sign">

        <div className = "sign__content">

          <div className = "logo" />
          
          <hr />

          <Textfield

            title = "Электронная почта"
            value = { email }
            set = { setEmail }
            placeholder = "Электронная почта"

          />

          <Textfield

            title = "Пароль"
            type = "password"
            value = { password }
            set = { setPassword }
            placeholder = "Введите пароль"

          />


          <Textfield

            title = "Повторите пароль"
            type = "password"
            value = { repeat }
            set = { setRepeat }
            placeholder = "Повторите пароль"

          />

          <hr />
          
          { error !== "" && <Fragment><p className = "error">{ error }</p><hr /></Fragment> }

          <Checkbox

            text = {

              <Fragment>
                Я принимаю условия <a href = { DOCUMENTS.offer } target = "_blank" rel = "norefferer" onClick = {( e ) => { e.stopPropagation(); }}>Договора-оферты</a>
              </Fragment>
              
            }
            value = { offerAccepted }
            set = { setOfferAccepted }

          />

          <Checkbox

            text = {
              <Fragment>
                Я принимаю условия <a href = { DOCUMENTS.privacy } target = "_blank" rel = "norefferer" onClick = {( e ) => { e.stopPropagation(); }}>Политики обработки персональных данных</a>, и даю согласие на обработку моих персональных данных
              </Fragment>
            }
            value = { privacyAccepted }
            set = { setPrivacyAccepted }

          />

          <Button
      
            action = { handleSignUp }
            text = "Зарегистрироваться"
            disabled = { !isFormValidated }

          />

          <p className = "text-center">у меня есть аккаунт</p>

          <ButtonRouter
      
            url = "/signin"
            text = "Войти"

          />
          
        </div>

      </div>

    </Container>

  );

}

export default Up;